import logo from "./logo.svg";
import "./Landingv2.css";

import avatarIcon from "../../Assests/avatar-icon.svg";
import DownloadIcon from "../../Assests/download-icon.svg";

import {
  Box,
  Button,
  Checkbox,
  FormControl,
  Grid,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Tab,
  Tabs,
} from "@mui/material";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import Logout from "@mui/icons-material/Logout";

import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";

import LandingVideo from "../../Assests/NetworkOptimizerApp.mp4";
import Bottomarrow from "../../Assests/path386.svg";
import arrowUpicon from "../../Assests/arrow-up-icon.svg";
import picture from "../../Assests/Picture2.png";
import uniopsLogo from "../../Assests/uniops-logo.png";
import unileverLogo from "../../Assests/Unileverlogo.png";
import aeravideo from "../../../public/AERAGuide.mp4";
import FileSaver, { saveAs } from "file-saver";
import { Document, Page } from "react-pdf";
import UploadModal from "../../Components/Modals/UploadModal";
import { useDispatch, useSelector } from "react-redux";
import {
  addPackingPlantAddMinorIngredient,
  addProcessingPackagingPlantsDiff,
  addSourceBePartOfOptimization,
  cloaseDonePopup,
  closeModal,
  createrFolderOrScenarioError,
  displayDashboardSummaryCost,
  displayDashboardSummaryCostError,
  displayDashboardSummaryCostSuccess,
  displayFolderList,
  displayFolderListError,
  displayFolderListSuccess,
  displayMonthNamesListSuccess,
  displayScenarioList,
  displayScenarioListError,
  displayScenarioListSuccess,
  enableEditFilter,
  goBack,
  isFolderExisted,
  nutritionDisplayDashboardSummaryCost,
  nutritionDisplayDashboardSummaryCostError,
  nutritionDisplayDashboardSummaryCostSuccess,
  openErrorDialog,
  openErrorOrWarningDialog,
  selectedCategoryListSuccess,
  selectedFolderListSuccess,
  selectedScenarioListSuccess,
  selectedTimePeriodSuccess,
  selectedUsecaseListSuccess,
} from "../../Redux/Actions/InputData";
import * as actions from "./../../Redux/Actions/index";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { signOutClickHandler } from "../../Services/auth-config";
import { BlobServiceClient } from "@azure/storage-blob";
import axios from "axios";
import _ from "underscore";
import { getRequest, postRequest } from "../../Services/AxiosConfiguration";
import {
  API_BASE_URL,
  USECASE_DETAILS_API,
  CATEGORY_DETAILS_API,
  // DISPLAY_FOLDER_LIST_BY_USECASE_API,
  DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API,
  DISPLAY_SUMMARY_COST_DASHBOARD,
  NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD,
  MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD,
  MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD,
  DISPLAY_SCENARIO_FILTER_API,
  DISPLAY_MONTH_NAMES_API,
  NUTRITION_DISPLAY_MONTH_NAMES_API,
  MEDIUM_HOME_DISPLAY_MONTH_NAMES_API,
  MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API,
  DOWNLOAD_GUROBI_API,
  NUTRITION_DOWNLOAD_GUROBI_API,
  MEDIUM_DOWNLOAD_GUROBI_API,
  NUTRITION_MEDIUM_DOWNLOAD_GUROBI_API,
  PROGRESS_BAR_DETAILS_API,
  // GET_SAS_URI_API,
  RERUN_PROGRESS_BAR_DETAILS_API,
  RERUN_HOMECARE_DETAILS_API,
  RERUN_NUTRITION_DETAILS_API,
  RERUN_MEDIUM_HOMECARE_DETAILS_API,
  RERUN_MEDIUM_NUTRITION_DETAILS_API,
  // CGO_FLOW_ADD_API,
  LONG_ADD_FOLDERSCENARIO_GET_API,
  LONG_ADD_SCENARIO_GET_API,
} from "../../Utils/Config";
import InputCapacityModal from "../../Components/Modals/LongTerm/InputCapacityModal";
import FolderModal from "../../Components/Modals/LongTerm/FolderModal";
import LongTermUploadModal from "../../Components/Modals/LongTerm/LongTermUploadModal";
import LongTermScenarioSelectionModal from "../../Components/Modals/LongTerm/LongTermScenarioSelectionModal";
import ErrorDialog from "../../Components/Modals/ErrorDialog";
import { ActivateOrDeactivateFolder } from "../../Services/FolderService";

const types = ["Great experience", "Reports", "Compare Scenarios"];
interface TabPanelProps {
  children?: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel: React.FC<TabPanelProps> = ({ children, value, index }) => {
  return value === index ? <div>{children}</div> : null;
};

const handleDownload = async () => {
  try {
    // Replace 'path_to_your_pdf_file' with the actual path or URL to your PDF file.
    const pdfUrl = "UserGuide.pdf";
    const pdfBlob = await fetch(pdfUrl).then((response) => response.blob());
    saveAs(pdfBlob, "downloaded_pdf.pdf");
  } catch (error) {
    console.error("Error downloading PDF:", error);
  }
};

function Landingv2() {
  const [value, setValue] = useState(0);
  const userData = useSelector(
    (state: any) => state.InputDataReducers.apiUserData,
  );
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const { instance } = useMsal();
  const openUserMenu = Boolean(anchorElUser);

  const [isNext, setIsNext] = useState(false);
  const [selectRadio, setSelectRadio] = React.useState("");
  const isUploadScenarioData = useSelector(
    (state: any) => state.InputDataReducers.isUploadScenario,
  );
  const [selectedCategoryId, setSelectedCategoryId] = useState<any>(0);
  const [selectedUsecaseeId, setSelectedUsecaseId] = useState<any>(0);
  const [isOpenBaseLineUploader, setIsOpenBaseLineUploader] = useState(false);
  const [isUploadMasterFile, setIsUploadMasterFile] = useState(false);
  const [selectedfile, setSelectedFile] = useState<any>({});
  const [selectedUsecase, setSelectedUsecase] = useState("");
  const isUploadBaseLineData = useSelector(
    (state: any) => state.InputDataReducers.isUploadBaseLineData,
  );

  const TabGroup = () => {
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
      setValue(newValue);
    };
    function a11yProps(index: number) {
      return {
        id: `full-width-tab-${index}`,
        "aria-controls": `full-width-tabpanel-${index}`,
      };
    }

    const setUsecase = (val: any) => {
      localStorage.setItem("selectedUsecase", val);
    };

    const clearStorage = () => {
      localStorage.clear();
    };

    // short and medium term
    const openShortTermPopup = (val: any) => {
      clearStorage();
      setIsSelectedScenarios(true);
      setIsOpenProceedModal(true);
      setUsecase(val);
    };
    // long term
    const pageLTRedirection = (val: any) => {
      // keep existing selections but route Long Term to dedicated modal
      setIsSelectedScenarios(true);
      setUsecase(val);
      if (val === "Long Term Analysis") {
        setIsOpenLongTermScenarioModal(true);
      } else {
        setIsOpenProceedModal(true);
      }
    };
    // COG
    const pageCGORedirection = (val: any) => {
      clearStorage();
      setIsSelectedScenarios(true);
      setIsOpenProceedModal(true);
      setUsecase("COG");
    };

    const modelRef = useRef(null);
    const navigate = useNavigate();
    const dispatch: any = useDispatch();
    const hiddenFileInput: any = React.useRef(null);
    const [isOpenUploadModal, setIsUploadModal] = useState(false);
    const [isOpenProceedModal, setIsOpenProceedModal] = useState(false);
    const [selectTimePeriod, setSelectTimePeriod] = useState<string[]>([
      "Time Period",
    ]);
    const [selectScenario, setSelectScenario] = useState<any>("Scenario");
    const [selectFolder, setSelectFolder] = useState<any>("Folder");
    const [selectUsecase, setSelectUsecase] = useState<any>("Use Case");
    const [selectCategory, setSelectCategory] = useState<any>("Category");
    const [sasUri, setSasUri] = useState("");
    const [reRun, setReRun] = useState("");

    const [selectedUsecaseeId, setSelectedUsecaseId] = useState<any>(0);
    const [selectedScenarioId, setSelectedScenarioId] = useState<any>();
    const [selectedFolderId, setSelectedFolderId] = useState<any>();
    // const [selectedUploadFolderId, setselectedUploadFolderId] = useState<any>();
    const [selectedCategoryId, setSelectedCategoryId] = useState<any>(0);
    const [duplicateScenario, setDuplicateScenario] = useState<any>(false);
    const [isOpenBaseLineUploader, setIsOpenBaseLineUploader] = useState(false);
    const [isUploadMasterFile, setIsUploadMasterFile] = React.useState(false);
    const [isFileUploadStatus, setIsFileUploadStatus] = React.useState(false);
    const [isEditFileStatus, setIsEditFileStatus] = React.useState(false);
    const [isEdit, setIsEdit] = React.useState(true);
    const [isNext, setIsNext] = React.useState(false);
    const [isNextLongTerm, setIsNextLongTerm] = React.useState(false);
    const [isLongTermUploadModal, setIsLongTermUploadModal] =
      React.useState(false);
    const [isSelectedScenarios, setIsSelectedScenarios] = React.useState(false);
    const [selectRadio, setSelectRadio] = React.useState("");
    const [selectedOption, setSelectedOption] = useState("");
    const [usecaseOptions, setUsecaseOptions] = React.useState([]);
    const [categoryOptions, setCategoryOptions] = useState<any>([]);
    const [folderOptions, setFolderOptions] = useState<any>([]);
    const [scenarioOptions, setScenarioOptions] = useState<any>([]);
    const [monthNameOptions, setMonthNamesOptions] = useState<any>([]);
    const [nutritionMonthNameOptions, setNutritionMonthNamesOptions] =
      useState<any>([]);

    const [selectedfile, setSelectedFile] = useState<any>({});
    const [selectedfileList, setSelectedFileList] = useState<any>([]);
    const [selectedItemId, setSelectedItemId] = useState("");
    const [uploadStatusData, setUploadStatusData] = useState<any>([]);
    const [rerunUploadStatusData, setRerunUploadStatusData] = useState<any>([]);
    const [reRunStatus, setReRunStatus] = useState<any>("");
    const [reRunSuccess, setReRunSuccess] = React.useState(false);
    const [uploadId, setUploadId] = React.useState("");
    const [isLongtermNext, setIsLongTermNext] = React.useState(false);
    const [isOpenLongTermScenarioModal, setIsOpenLongTermScenarioModal] =
      React.useState(false);

    const selectedUsecaseId = useSelector(
      (state: any) => state.InputDataReducers.selectedUsecaseId,
    );

    const selectedCategoryIdd = useSelector(
      (state: any) => state.InputDataReducers.selectedCategoryId,
    );

    const sortedScenarioNames = scenarioOptions.sort((a: any, b: any) =>
      a?.scenario.localeCompare(b?.scenario),
    );

    const sortedFolderNames = folderOptions.sort((a: any, b: any) =>
      a?.folder.localeCompare(b?.folder),
    );
    const [isDownLoadDisable, setIsDownLoadDisable] = useState<any>(false);

    const homeMasterData: any = [
      {
        id: 1,
        name: "Manufacturing Master1*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
        align: "left",
        headerAlign: "left",
      },
      {
        id: 2,
        name: "Cascade Master*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
        align: "left",
        headerAlign: "left",
      },
      {
        id: 3,
        name: "Facility Master*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
        align: "left",
        headerAlign: "left",
      },
      {
        id: 4,
        name: "Shift & Changeover*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
        align: "left",
        headerAlign: "left",
      },
    ];

    const homeInputLine: any = [
      {
        id: 1,
        name: "Landed Cost2*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 2,
        name: "OEE & CPT*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 3,
        name: "Demand*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 4,
        name: "Primary Transportation*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
    ];
    const nutritionMasterData: any = [
      {
        id: 1,
        name: "Facility Master3*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 2,
        name: "Manufacturing Master*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 3,
        name: "BOM*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 4,
        name: "Packaging Master*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 5,
        name: "Cascade Master*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 6,
        name: "Shift & Changeover*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
    ];

    const nutritionInputLine = [
      {
        id: 1,
        name: "Minor Ingredient Landed Cost4*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 2,
        name: "SFG Landed Cost*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 3,
        name: "Manufacturing OPE & CPT*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 4,
        name: "Packaging OEE & CPT*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 5,
        name: "Demand*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 6,
        name: "SFG transportation*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 7,
        name: "Primary Transportation*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
    ];

    const mediumHomeScenario: any = [
      {
        id: 1,
        name: "Landed Cost5*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 2,
        name: "OEE & CPT*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 3,
        name: "Demand*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 4,
        name: "Primary Transportation*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 5,
        name: "Cascade Master(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 6,
        name: "Shift&Changeover(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 7,
        name: "ManufactureMaster&OEE(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
    ];
    const mediumNutritionScenario = [
      {
        id: 1,
        name: "Minor Ingredient Landed Cost6*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 2,
        name: "SFG Landed Cost*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 3,
        name: "Manufacturing OPE & CPT*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 4,
        name: "Packaging OEE & CPT*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 5,
        name: "Demand*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 6,
        name: "SFG transportation*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 7,
        name: "Primary Transportation*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 8,
        name: "CascadeMaster(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 9,
        name: "ManfactureMasterandOPE(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 10,
        name: "PackagingMasterandOEE(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
      {
        id: 11,
        name: "ShiftandChangeover(AddCap)*",
        btnName: "upload",
        selectedFile: {},
        ref: React.useRef(null),
      },
    ];

    const masterData: any =
      selectedCategoryIdd !== 2 ? homeMasterData : nutritionMasterData;

    const isCreateFolder = useSelector(
      (state: any) => state.InputDataReducers.isCreateFolder,
    );

    const isUploadScenarioData = useSelector(
      (state: any) => state.InputDataReducers.isUploadScenario,
    );
    const isUploadBaseLineData = useSelector(
      (state: any) => state.InputDataReducers.isUploadBaseLineData,
    );

    const inputFolderValue = useSelector(
      (state: any) => state.InputDataReducers.inputFolderName,
    );

    const { scenarioData, isScenarioCreated } = useSelector(
      (state: any) => state.InputDataReducers,
    );

    const { dashboardSummaryCost, isDone, isLoading, uploadMasterFileMessage } =
      useSelector((state: any) => state.InputDataReducers);
    const isBaseLineUploader = useSelector(
      (state: any) => state.InputDataReducers.isBaseLineUploader,
    );
    const isFolderCreated = useSelector(
      (state: any) => state.InputDataReducers.isFolderCreated,
    );

    const uploadFolderId = useSelector(
      (state: any) => state.InputDataReducers.selectedUpload,
    );

    const selectedTimePeriodData = useSelector(
      (state: any) => state.InputDataReducers.selectedTimePeriodData,
    );

    /**Redux state */
    const uploadSelectedFolderId = useSelector(
      (state: any) => state.InputDataReducers.selectedUploadFolderId,
    );

    const isFileUpload = useSelector(
      (state: any) => state.InputDataReducers.fileUploadStatus,
    );

    const { isFolderSelected, folderSelectionMessage } = useSelector(
      (state: any) => state.InputDataReducers,
    );

    const uploadScenarioId = useSelector(
      (state: any) => state.InputDataReducers.selectedUploadScenarioId,
    );

    // const userData = useSelector(
    //   (state: any) => state.InputDataReducers.apiUserData
    // );
    // console.log(userData, "userData");
    const {
      isErrorDialog,
      errorMessage,
      isErrorOrWarningDialog,
      errorOrWarningMessage,
    } = useSelector((state: any) => state.InputDataReducers);

    const isDuplicateScenarioCreated = useSelector(
      (state: any) => state.InputDataReducers.isDuplicateScenarioCreated,
    );

    const isEditEnabled = useSelector(
      (state: any) => state.InputDataReducers.editFilterEnable,
    );

    // suren
    const [showFullOverlay, setfullOverlayDetails] = useState(true);

    var inputLine: any;
    useEffect(() => {
      if (selectedUsecaseId === 1) {
        if (selectedCategoryIdd === 1) {
          setGetInputLineData(homeInputLine);
        } else {
          setGetInputLineData(nutritionInputLine);
        }
      } else {
        if (selectedCategoryIdd === 2) {
          if (isUploadScenarioData) {
            setGetInputLineData(mediumNutritionScenario);
          } else {
            setGetInputLineData(nutritionInputLine);
          }
        } else {
          if (isUploadScenarioData) {
            setGetInputLineData(mediumHomeScenario);
          } else {
            setGetInputLineData(homeInputLine);
          }
          // setGetInputLineData(isUploadScenarioData ? mediumHomeScenario : homeInputLine);
        }
      }
    }, [selectedUsecaseId, selectedCategoryIdd, isUploadScenarioData]);

    const [getMasterData, setGetMasterData] = useState(masterData);
    const [getInputLineData, setGetInputLineData] = useState(inputLine);

    const [selectedfilesList, setSelectedFilesList] = useState<any>([]);
    const [isUploadReady, setIsUploadReady] = useState<any>(false);
    const [openEditDialog, setOpenEditDialog] = useState<any>(false);
    const [openReRunDialog, setOpenReRunDialog] = useState<any>(false);
    const [uploadReRunStatus, setUploadReRunStatus] = useState<any>(false);
    const [openReRunDialogStatus, setOpenReRunDialogStatus] = useState<any>("");
    const [reRunDialogStatus, setReRunDialogStatus] = useState<any>("");
    const [fileTypeName, setFileTypeName] = useState<any>("");

    const [loader, setLoader] = useState<any>(false);

    useEffect(() => {
      setSelectedFileList([]);
      //callFolderFilterApi();
    }, []);

    useEffect(() => {
      if (
        selectedFolderId !== undefined &&
        selectedFolderId !== 0 &&
        selectedFolderId !== ""
      ) {
        if (selectedUsecaseId === 1) {
          if (selectedCategoryId === 1) {
            callMonthFilterApi(selectedScenarioId);
          } else {
            nutritionCallMonthFilterApi(selectedScenarioId);
          }
        } else {
          if (selectedCategoryId === 1) {
            mediumHomecallMonthFilterApi(selectedScenarioId);
          } else {
            mediumNutritionCallMonthFilterApi(selectedScenarioId);
          }
        }
      }
    }, [selectedScenarioId]);

    useEffect(() => {
      if (
        selectedFolderId !== undefined &&
        selectedFolderId !== 0 &&
        selectedFolderId !== ""
      ) {
        callScenarioFilterApi({ id: selectedFolderId });
      }
    }, [isDuplicateScenarioCreated, isScenarioCreated]);

    useEffect(() => {
      const urls = API_BASE_URL + USECASE_DETAILS_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(urls, {}, header)
        .then((response) => {
          if (response.status === 200 && response.data) {
            let responseArray = [];
            responseArray.push(response.data);
            setUsecaseOptions(response.data);
            dispatch(displayScenarioListSuccess(response.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    }, []);

    useEffect(() => {
      const urls = API_BASE_URL + CATEGORY_DETAILS_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(urls, {}, header)
        .then((response) => {
          if (response.status === 200 && response.data) {
            setCategoryOptions(response.data);
            dispatch(displayScenarioListSuccess(response.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    }, []);

    var mainStatus = false;

    const callFolderFilterApi = (useCaseId: number, categoryId: number) => {
      dispatch(displayFolderList());
      const urls = API_BASE_URL + DISPLAY_FOLDER_LIST_BY_USECASE_AND_USERID_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          useCase: useCaseId,
          category: categoryId,
          createdBy: userData.userId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setFolderOptions(response.data.data);
            dispatch(displayFolderListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayFolderListError(error.message));
        });
    };

    const getSummaryCostForDashboard = (folderId: any, scenarioId: any) => {
      dispatch(displayDashboardSummaryCost());
      const urls = API_BASE_URL + DISPLAY_SUMMARY_COST_DASHBOARD;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: folderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          // if (response.status === 200 && response.data.success) {
          //   setFolderOptions(response.data.data);
          dispatch(displayDashboardSummaryCostSuccess(response.data));
          // }
        })
        .catch((error) => {
          // dispatch(openErrorDialog(error));
          dispatch(displayDashboardSummaryCostError(error.message));
        });
    };

    const nutritionGetSummaryCostForDashboard = (
      folderId: any,
      scenarioId: any,
    ) => {
      dispatch(nutritionDisplayDashboardSummaryCost());
      const urls = API_BASE_URL + NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: folderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          dispatch(nutritionDisplayDashboardSummaryCostSuccess(response?.data));
          // }
        })
        .catch((error) => {
          // dispatch(openErrorDialog(error));
          dispatch(nutritionDisplayDashboardSummaryCostError(error.message));
        });
    };

    const MediumgetSummaryCostForDashboard = (
      folderId: any,
      scenarioId: any,
    ) => {
      dispatch(displayDashboardSummaryCost());
      const urls = API_BASE_URL + MEDIUM_DISPLAY_SUMMARY_COST_DASHBOARD;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: folderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          // if (response.status === 200 && response.data.success) {
          //   setFolderOptions(response.data.data);
          dispatch(displayDashboardSummaryCostSuccess(response.data));
          // }
        })
        .catch((error) => {
          // dispatch(openErrorDialog(error));
          dispatch(displayDashboardSummaryCostError(error.message));
        });
    };

    const MediumnutritionGetSummaryCostForDashboard = (
      folderId: any,
      scenarioId: any,
    ) => {
      dispatch(nutritionDisplayDashboardSummaryCost());
      const urls =
        API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_SUMMARY_COST_DASHBOARD;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id: folderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          dispatch(nutritionDisplayDashboardSummaryCostSuccess(response?.data));
          // }
        })
        .catch((error) => {
          // dispatch(openErrorDialog(error));
          dispatch(nutritionDisplayDashboardSummaryCostError(error.message));
        });
    };

    const handleUploadFile = (e: any, item: any, index: number) => {
      e.preventDefault();
      //hiddenFileInput.current.click();
      if (selectRadio === "inputData") {
        getInputLineData[index]?.ref.current.click();
        // e.target.value = null;
        clearInterval(getInputLineData[index].ref.current);
        //hiddenFileInput.current = null;
        // getInputLineData[index].ref.current = null;
        setSelectedItemId(item.id);
      } else {
        getMasterData[index]?.ref?.current?.click();
        // e.target.value = null;
        clearInterval(getMasterData[index]?.ref.current);
        //hiddenFileInput.current = null;
        // getMasterData[index].ref.current = null;
        setSelectedItemId(item.id);
      }
    };

    const handleChangeFileUpload = (e: any) => {
      selectedfileList.length = 0;
      const fileUploaded = e.target.files[0];
      selectedfileList.push(fileUploaded.name);
      selectedfilesList.push({
        filename: fileUploaded.name,
        filedata: fileUploaded,
      });
      if (!fileUploaded) {
        return;
      }
      if (selectRadio === "inputData") {
        const newArr = getInputLineData.map((ele: any, i: any) => {
          if (selectedItemId === ele.id) {
            ele.selectedFile = fileUploaded;
          }
          return ele;
        });
        setGetMasterData(newArr);
      } else {
        const newArr = getMasterData.map((ele: any, i: any) => {
          if (selectedItemId === ele.id) {
            ele.selectedFile = fileUploaded;
          }
          return ele;
        });
        setGetMasterData(newArr);
      }
      setSelectedFile(fileUploaded);
    };

    const handleCancelFile = (e: any, elem: any) => {
      if (selectRadio === "inputData") {
        const newArr = getInputLineData?.filter((ele: any, i: any) => {
          if (ele.id === elem.id) {
            ele.selectedFile = {};
          }
          return ele;
        });
        setGetMasterData(newArr);
      } else {
        const newArr = getMasterData?.filter((ele: any, i: any) => {
          if (ele.id === elem.id) {
            ele.selectedFile = {};
          }
          return ele;
        });
        setGetMasterData(newArr);
      }
    };

    const callScenarioFilterApi = (params: any) => {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + DISPLAY_SCENARIO_FILTER_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };
      getRequest(
        urls,
        { folder_id: params.id, createdBy: userData.userId },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data) {
            let responseArray = [];
            //responseArray.push(response.data);
            //
            setScenarioOptions(response.data);
            dispatch(displayScenarioListSuccess(response.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    };

    const callMonthFilterApi = (scenarioId: number) => {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + DISPLAY_MONTH_NAMES_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      getRequest(
        urls,
        {
          usecase_id: selectedUsecaseeId,
          category_id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setMonthNamesOptions(response.data.data);
            dispatch(displayMonthNamesListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    };

    const nutritionCallMonthFilterApi = (scenarioId: number) => {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + NUTRITION_DISPLAY_MONTH_NAMES_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      getRequest(
        urls,
        {
          usecase_id: selectedUsecaseeId,
          category_id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            // let responseArray = [];
            // responseArray.push(response.data);
            // setMonthNamesOptions(response.data);
            // dispatch(displayMonthNamesListSuccess(response.data));
            setNutritionMonthNamesOptions(response.data.data);
            dispatch(displayMonthNamesListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    };

    const mediumHomecallMonthFilterApi = (scenarioId: number) => {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + MEDIUM_HOME_DISPLAY_MONTH_NAMES_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      getRequest(
        urls,
        {
          usecase_id: selectedUsecaseeId,
          category_id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            setMonthNamesOptions(response.data.data);
            dispatch(displayMonthNamesListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    };

    const mediumNutritionCallMonthFilterApi = (scenarioId: number) => {
      dispatch(displayScenarioList());
      const urls = API_BASE_URL + MEDIUM_NUTRITION_DISPLAY_MONTH_NAMES_API;
      const header = {
        accept: "application/json",
        "Content-Type": "application/json",
      };

      getRequest(
        urls,
        {
          usecase_id: selectedUsecaseeId,
          category_id: selectedCategoryId,
          folder_id: selectedFolderId,
          scenario_id: scenarioId,
        },
        header,
      )
        .then((response) => {
          if (response.status === 200 && response.data.success) {
            // let responseArray = [];
            // responseArray.push(response.data);
            // setMonthNamesOptions(response.data);
            // dispatch(displayMonthNamesListSuccess(response.data));
            setNutritionMonthNamesOptions(response.data.data);
            dispatch(displayMonthNamesListSuccess(response.data.data));
          }
        })
        .catch((error) => {
          dispatch(openErrorDialog(error));
          dispatch(displayScenarioListError(error.message));
        });
    };
    const handleChangeRadio = (e: any) => {
      setUploadStatusData([]);
      setRerunUploadStatusData([]);
      e.preventDefault();
      const value = e.target.value;
      setSelectRadio(value);

      if (isSelectedScenarios === true) {
        // if (e === "masterData") {
        //   setSelectedOption("CGOMaster");
        // } else {
        //   setSelectedOption("CGOInput");
        //   window.location.href = "/CGOHome"
        // }
      } else {
        if (value === "masterData") {
          setGetMasterData(masterData);
        } else {
          setGetMasterData(inputLine);
          //setGetInputLineData(inputLine)
        }
      }
    };

    const handleChangeTimePeriod = (event: any) => {
      const {
        target: { value },
      } = event;
      setSelectTimePeriod(value);

      const filtereddata = value.filter((timePeriod: any) => {
        // if(scenario.scenario_id !== value.scenario_id && scenario.scenario !=='BaseLine')
        if (timePeriod !== "Select Time Period") return timePeriod;
      });
      dispatch(selectedTimePeriodSuccess(filtereddata));
    };

    const handleGurobiDownload = () => {
      if (selectedScenarioId > 0) {
        //setIsDownLoadDisable(false);
        if (selectedUsecaseId > 1) {
          if (selectedCategoryId === 1) {
            MediumdownloadGurobiFile();
          } else {
            MediumnutritionDownloadGurobiFile();
          }
        } else {
          if (selectedCategoryId === 1) {
            downloadGurobiFile();
          } else {
            nutritionDownloadGurobiFile();
          }
        }
      } else {
        //setIsDownLoadDisable(true);
        dispatch(
          openErrorOrWarningDialog("Please select atleast one Scenario."),
        );
      }
    };

    const downloadGurobiFile = async () => {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
      };
      const urls = API_BASE_URL + DOWNLOAD_GUROBI_API;
      axios({
        url: urls,
        method: "post",
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //FileSaver(blob, Date.now() + '.xlsx');
        FileSaver(blob, "Optimized Output.xlsx");
      });
    };

    const nutritionDownloadGurobiFile = async () => {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
      };
      const urls = API_BASE_URL + NUTRITION_DOWNLOAD_GUROBI_API;
      axios({
        url: urls,
        method: "post",
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //FileSaver(blob, Date.now() + '.xlsx');
        FileSaver(blob, "Nutrition Optimized Output.xlsx");
      });
    };

    const MediumdownloadGurobiFile = async () => {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
      };
      const urls = API_BASE_URL + MEDIUM_DOWNLOAD_GUROBI_API;
      axios({
        url: urls,
        method: "post",
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //FileSaver(blob, Date.now() + '.xlsx');
        FileSaver(blob, "Optimized Output.xlsx");
      });
    };

    const MediumnutritionDownloadGurobiFile = async () => {
      const requestParam = {
        usecaseId: selectedUsecaseeId,
        category_Id: selectedCategoryId,
        folder_id: selectedFolderId,
        scenario_id: selectedScenarioId,
      };
      const urls = API_BASE_URL + NUTRITION_MEDIUM_DOWNLOAD_GUROBI_API;
      axios({
        url: urls,
        method: "post",
        responseType: "arraybuffer",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        //FileSaver(blob, Date.now() + '.xlsx');
        FileSaver(blob, "Nutrition Optimized Output.xlsx");
      });
    };

    const handleChangeSelectScenario = (event: any) => {
      // dispatch(selectedScenarioList());
      if (isEditEnabled === false || isEditEnabled === undefined) {
        const {
          target: { value },
        } = event;
        setSelectScenario(value.scenario);
        setIsFileUploadStatus(false);
        setSelectedScenarioId(value.scenario_id);
        dispatch(selectedScenarioListSuccess(value));
        dispatch(enableEditFilter(false, "handlescenario"));
        callMonthFilterApi(value?.scenario_id);
        nutritionCallMonthFilterApi(value?.scenario_id);
        if (selectedUsecaseId === 1) {
          if (selectedCategoryId === 1) {
            getSummaryCostForDashboard(selectedFolderId, value?.scenario_id);
          } else {
            nutritionGetSummaryCostForDashboard(
              selectedFolderId,
              value?.scenario_id,
            );
          }
        } else {
          if (selectedCategoryId === 1) {
            MediumgetSummaryCostForDashboard(
              selectedFolderId,
              value?.scenario_id,
            );
          } else {
            MediumnutritionGetSummaryCostForDashboard(
              selectedFolderId,
              value?.scenario_id,
            );
          }
        }
      } else {
        setIsEditFileStatus(true);
      }
    };

    const handleChangeSelectFolder = (event: any) => {
      if (isEditEnabled === false || isEditEnabled === undefined) {
        const {
          target: { value },
        } = event;
        setSelectFolder(value.folder);
        setSelectedScenarioId(0);
        setSelectedFolderId(value.id);
        dispatch(selectedFolderListSuccess(value));
        callScenarioFilterApi(value);
        setIsEdit(!isEdit);
        dispatch(enableEditFilter(false, "handlefolder"));
        setIsFileUploadStatus(false);

        // getSummaryCostForDashboard(selectedFolderId, value.scenario_id);
        if (selectedUsecaseId === 1) {
          if (selectedCategoryId === 1) {
            getSummaryCostForDashboard(value.id, 0);
          } else {
            nutritionGetSummaryCostForDashboard(value.id, 0);
          }
        } else {
          if (selectedCategoryId === 1) {
            MediumgetSummaryCostForDashboard(value.id, 0);
          } else {
            MediumnutritionGetSummaryCostForDashboard(value.id, 0);
          }
        }
        setSelectScenario("BaseLine");
        //callMonthFilterApi();
      } else {
        setIsEditFileStatus(true);
      }
    };
    const handleClickSelectFolder = (event: any) => {
      if (
        selectedUsecaseId === undefined ||
        selectedUsecaseId === 0 ||
        selectedCategoryId === undefined ||
        selectedCategoryId === 0
      ) {
        //setPageIsLoaded(true);
        //setPageIsDefaultLoaded(true);
        //dispatch(openErrorDialog("Default"));
        dispatch(
          openErrorOrWarningDialog(
            "Please select atleast one usecase and category",
          ),
        );
      } else {
        //setPageIsLoaded(false);
        //setPageIsDefaultLoaded(false);
      }
    };

    const handleClickSelectScenario = (event: any) => {
      if (selectedFolderId === undefined || selectedFolderId === 0) {
        //setPageIsLoaded(true);
        //setPageIsDefaultLoaded(true);
        //dispatch(openErrorDialog("Default"));
        dispatch(
          openErrorOrWarningDialog(
            "Please select atleast one usecase, category and folder.",
          ),
        );
      } else {
        //setPageIsLoaded(false);
        //setPageIsDefaultLoaded(false);
      }
    };

    const handleClickSelectTimePeriod = (event: any) => {
      if (selectedScenarioId === undefined) {
        //setPageIsLoaded(true);
        //setPageIsDefaultLoaded(true);
        //dispatch(openErrorDialog("Default"));
        dispatch(
          openErrorOrWarningDialog(
            "Please select atleast one usecase, category, folder and scenario.",
          ),
        );
      } else {
        //setPageIsLoaded(false);
        //setPageIsDefaultLoaded(false);
      }
    };

    // useEffect(()=>
    // {
    //   setPageIsLoaded(pageIsDefaultLoaded);
    // },[pageIsDefaultLoaded])

    const setInitialValues = () => {
      setSelectFolder("Folder");
      setSelectedFolderId("");
      setSelectedScenarioId("");
      dispatch(selectedTimePeriodSuccess([]));
      dispatch(selectedFolderListSuccess(0));
      dispatch(selectedScenarioListSuccess(0));
      setScenarioOptions([]);
      setMonthNamesOptions([]);
      setSelectScenario("Scenario");
      setSelectTimePeriod(["Time Period"]);
    };
    const handleChangeUsecase = (event: any) => {
      // dispatch(selectedUseCaseList());
      if (isEditEnabled === false || isEditEnabled === undefined) {
        const {
          target: { value },
        } = event;
        setSelectUsecase(value.name);
        setSelectedUsecaseId(value.id);
        setIsFileUploadStatus(false);
        dispatch(selectedUsecaseListSuccess(value));
        if (value.id !== 0 && selectedCategoryId !== 0) {
          callFolderFilterApi(value.id, selectedCategoryId);
        }
        setInitialValues();
      } else {
        setIsEditFileStatus(true);
      }
    };

    const handleChangeCategory = (event: any) => {
      if (isEditEnabled === false || isEditEnabled === undefined) {
        const {
          target: { value },
        } = event;

        setSelectCategory(value.name);
        setIsFileUploadStatus(false);
        setSelectedCategoryId(value.id);
        dispatch(selectedCategoryListSuccess(value));
        setInitialValues();
        if (selectedUsecaseeId !== 0 && value.id !== 0) {
          callFolderFilterApi(selectedUsecaseeId, value.id);
        }
        // setIsEdit(!isEdit);
        dispatch(enableEditFilter(false, "handlecat"));
      } else {
        setIsEditFileStatus(true);
      }
    };

    const categoryChange = (cateory: any) => {
      if (isEditEnabled === false || isEditEnabled === undefined) {
        /* const {
          target: { value },
        } = event; */
        setSelectCategory(cateory);
        setIsFileUploadStatus(false);
        //setSelectedCategoryId(value.id);
        dispatch(selectedCategoryListSuccess(cateory));
        setInitialValues();
        // setIsEdit(!isEdit);
        dispatch(enableEditFilter(false, "handlecat"));
      } else {
        setIsEditFileStatus(true);
      }
    };

    /* useEffect(() => {
      if(localStorage.getItem('selectedCategory') !== null){
        const category = localStorage.getItem('selectedCategory')
        categoryChange(category)
      }
    }, []) */

    const handleUploadData = () => {
      setfullOverlayDetails(false);

      setSelectRadio("");
      if (
        selectedUsecaseeId !== undefined &&
        selectedUsecaseeId !== 0 &&
        selectedCategoryId !== undefined &&
        selectedCategoryId !== 0
      ) {
        dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
        dispatch(selectedCategoryListSuccess(selectedCategoryId));
        dispatch(selectedFolderListSuccess(selectedFolderId));
        setIsUploadModal(true);
      } else {
        //setPageIsLoaded(true);
        //setIsUploadReady(true);
        dispatch(
          openErrorOrWarningDialog(
            "Please select atleast one usecase and category",
          ),
        );
      }
    };

    //close modal when click on closs button
    const closeUploadModal = () => {
      // dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      // dispatch(selectedCategoryListSuccess(selectedCategoryId));
      setSelectedOption("");
      setIsOpenProceedModal(false);
      setIsUploadModal(false);
      setIsNext(false);
      // setGetMasterData(masterData);
      setGetInputLineData((previousData: any) => previousData);
      setSelectRadio("");
      setSelectedFile({});
      setIsUploadMasterFile(false);
      dispatch(closeModal());
      dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      dispatch(selectedCategoryListSuccess(selectedCategoryId));
      dispatch(selectedFolderListSuccess(selectedFolderId));
      dispatch(selectedScenarioListSuccess(selectedScenarioId));
      dispatch(displayDashboardSummaryCostSuccess(dashboardSummaryCost));
    };

    const handleOpenDuplicateScenario = () => {
      if (
        selectedUsecaseeId !== undefined &&
        selectedUsecaseeId !== 0 &&
        selectedCategoryId !== undefined &&
        selectedCategoryId !== 0
      ) {
        dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
        dispatch(selectedCategoryListSuccess(selectedCategoryId));
        //setPageIsLoaded(false);

        setDuplicateScenario(true);
        dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
        dispatch(selectedCategoryListSuccess(selectedCategoryId));
      } else {
        //setPageIsLoaded(true);
        //dispatch(openErrorDialog("Default"));
        dispatch(
          openErrorOrWarningDialog(
            "Please select atleast one usecase and category",
          ),
        );
      }
    };

    const cancelDuplicate = () => {
      setDuplicateScenario(false);
    };

    const handleOpenBaseLineUploader = () => {
      setIsOpenBaseLineUploader(true);
    };

    const closeBaseLineUploader = () => {
      setIsOpenBaseLineUploader(false);
    };

    const handleCloseDonePopup = () => {
      setIsNext(false);
      setIsUploadMasterFile(false);
      dispatch(cloaseDonePopup());
      if (selectRadio === "inputData") {
        const newArr = getInputLineData.filter((ele: any, i: any) => {
          if (ele.id === selectedItemId) {
            ele.selectedFile = {};
          }
          return ele;
        });
        setGetInputLineData(newArr);
      } else {
        const newArr = getMasterData.filter((ele: any, i: any) => {
          if (ele.id === selectedItemId) {
            ele.selectedFile = {};
          }
          return ele;
        });
        setGetMasterData(newArr);
      }
      dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
      dispatch(selectedCategoryListSuccess(selectedCategoryId));
      dispatch(selectedFolderListSuccess(selectedFolderId));
      dispatch(selectedScenarioListSuccess(selectedScenarioId));
    };

    const [intervalId, setIntervalId] = useState<any>(null);
    let statusCount = 0;
    let processingCount = 0;
    let failedCount = 0;
    let gurobiCount = 0;
    const [loading, setLoading] = useState(false);
    const [reRunloading, setReRunLoading] = useState(false);
    const selected_folder_id =
      selectedFolderId !== "" ? selectedFolderId : uploadSelectedFolderId;

    const handleOpenApicall = (urls: any, requestParam: any) => {
      axios({
        url: urls,
        method: "post",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      }).then((response) => {
        if (response.status === 200) {
          setUploadStatusData(response.data);
        }
      });
    };

    const handleOpen = () => {
      setOpen(true);
      setUploadStatusData([]);
      setOpenReRunDialogStatus("");
      if (Number(selected_folder_id) > 0) {
        const requestParam = {
          usecaseId: selectedUsecaseeId,
          category_Id: selectedCategoryId,
          folder_id:
            uploadSelectedFolderId !== ""
              ? uploadSelectedFolderId
              : selectedFolderId,
          scenario_id: uploadScenarioId === 0 ? scenario_id : uploadScenarioId,
        };

        setLoading(true);
        const urls = API_BASE_URL + PROGRESS_BAR_DETAILS_API;
        const apicallInterval = setInterval(() => {
          handleOpenApicall(urls, requestParam);
        }, 5000);
        setIntervalId(apicallInterval);
      }
    };

    useEffect(() => {
      setOpenReRunDialogStatus("");
      if (selectedCategoryId > 0 && selectedUsecaseId > 0) {
        if (isDone) {
          let isScenarioData = false;
          {
            uploadStatusData.map((item: any) => {
              item.status.includes("Gurobi")
                ? (isScenarioData = true)
                : (isScenarioData = false);
            });
          }
          {
            uploadStatusData.map((item: any) => {
              var statusstring = item.status;
              if (
                statusstring.includes("Master Successfully Completed") &&
                !isScenarioData
              ) {
                statusCount++;
                setLoading(false);
                if (intervalId !== null) {
                  clearInterval(intervalId);
                }
              }
              if (statusstring.includes("Gurobi Successfully Completed")) {
                gurobiCount++;
                statusCount = 0;
                setLoading(false);
                if (intervalId !== null) {
                  clearInterval(intervalId);
                }
              }
              if (statusstring?.toLowerCase().includes("processing")) {
                processingCount++;
              }
              if (statusstring?.toLowerCase().includes("failed")) {
                failedCount++;
                processingCount = 0;
                statusCount = 0;
                setLoading(false);
                if (intervalId !== null) {
                  clearInterval(intervalId);
                }
              }
            });
          }

          if (
            uploadStatusData.length > 0 &&
            gurobiCount > 0 &&
            failedCount === 0
          ) {
            setOpenReRunDialogStatus("Gurobi Data uploaded successfully!");
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
          if (
            uploadStatusData.length > 0 &&
            statusCount > 0 &&
            failedCount === 0
          ) {
            setOpenReRunDialogStatus("Data uploaded successfully!");
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
          if (processingCount > 0) {
            setOpenReRunDialogStatus("Data upload in Progress");
          }
          if (failedCount > 0) {
            setOpenReRunDialogStatus("Data upload Failed");
            ActivateOrDeactivateFolder(selectedUsecaseId, selectedFolderId, 0);
            if (intervalId !== null) {
              clearInterval(intervalId);
            }
          }
        }
      }
    }, [isDone, uploadStatusData]);

    const handleEdit = () => {
      if (
        selectedUsecaseId > 0 &&
        selectedCategoryId > 0 &&
        selectedFolderId > 0
      ) {
        //   if(selectedCategoryId === 1) {
        //     const requestParam = { usecaseId:selectedUsecaseeId,category_Id:selectedCategoryId, "folder_id": selectedFolderId, "scenario_id": selectedScenarioId};
        //     const urls = API_BASE_URL + RERUN_EDIT_HOMECARE_DETAILS_API;
        //     axios({url: urls, method: 'post', headers: { 'Content-Type': 'application/json;'}, data: requestParam}).then((response) => {
        //       if(response.status === 200)
        //         dispatch(enableEditFilter(false, 'handleedit'));
        //     // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        //     //FileSaver(blob, Date.now() + '.xlsx');
        //     // FileSaver(blob, 'Optimized Output.xlsx');
        //   });
        // }else {
        //   const requestParam = { usecaseId:selectedUsecaseeId,category_Id:selectedCategoryId, "folder_id": selectedFolderId, "scenario_id": selectedScenarioId};
        //   const urls = API_BASE_URL + RERUN_EDIT_NUTRITION_DETAILS_API;
        //   axios({url: urls, method: 'post', headers: { 'Content-Type': 'application/json;'}, data: requestParam}).then((response) => {
        //     if(response.status === 200)
        //         dispatch(enableEditFilter(false, 'handleedit'));
        //     // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        //     //FileSaver(blob, Date.now() + '.xlsx');
        //     // FileSaver(blob, 'Optimized Output.xlsx');
        //   });
        // }

        dispatch(enableEditFilter(false, "handleedit"));

        setIsEdit(!isEdit);
      }
      handleOpenCloseEditDialog();
    };

    let reRunIntervalId: any;
    const rerunApiCall = (urls: any, requestParam: any) => {
      axios({
        url: urls,
        method: "post",
        headers: { "Content-Type": "application/json;" },
        data: requestParam,
      })
        .then((response) => {
          if (response?.status === 200) {
            setRerunUploadStatusData(response?.data);
            clearInterval(reRunIntervalId);
          } else {
            console.log(response, "errorDataS");

            // dispatch(enableEditFilter(false, 'handlecat'));
            //setReRunStatus("Rerun failed");
          }
        })
        .catch((e) => {
          clearInterval(reRunIntervalId);
        });
    };

    const handleRerunData = () => {
      if (selectedCategoryId === 1) {
        const interval = setInterval(() => {
          const requestParam = {
            usecaseId: selectedUsecaseeId,
            category_Id: selectedCategoryId,
            folder_id: selectedFolderId,
            scenario_id: selectedScenarioId,
          };
          setReRunLoading(true);
          setUploadReRunStatus(true);
          const urls = API_BASE_URL + RERUN_PROGRESS_BAR_DETAILS_API;

          // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
          axios({
            url: urls,
            method: "post",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            // if (response?.data?.toLowerCase() === "success") {
            setRerunUploadStatusData(response?.data);
            // }
          });
        }, 5000);
        setIntervalId(interval);

        // clearInterval(reRunIntervalId)
      } else {
        const nutritionInterval = setInterval(() => {
          const requestParam = {
            usecaseId: selectedUsecaseeId,
            category_Id: selectedCategoryId,
            folder_id: selectedFolderId,
            scenario_id: selectedScenarioId,
          };
          const urls = API_BASE_URL + RERUN_PROGRESS_BAR_DETAILS_API;
          axios({
            url: urls,
            method: "post",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          }).then((response) => {
            // if (response?.data?.toLowerCase() === "success") {
            setUploadReRunStatus(true);
            setRerunUploadStatusData(response?.data);
            // }
          });
        }, 5000);

        setIntervalId(nutritionInterval);
        //  return()=>clearInterval(nutritionInterval);
      }
    };

    const handleRerun = (e: any) => {
      setOpenReRunDialogStatus("");
      if (selectedUsecaseId === 1) {
        if (selectedCategoryId === 1) {
          const requestParam = {
            usecaseId: selectedUsecaseeId,
            category_Id: selectedCategoryId,
            folder_id: selectedFolderId,
            scenario_id: selectedScenarioId,
          };
          const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;

          // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
          axios({
            url: urls,
            method: "post",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          })
            .then((response) => {
              if (response?.data?.toLowerCase() === "success") {
                //handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                setReRunSuccess(true);
                handleRerunData();
              } else {
                handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                setReRunStatus(
                  "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
                );
                //handleRerunData();
              }
              // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
              //FileSaver(blob, Date.now() + '.xlsx');
              // FileSaver(blob, 'Optimized Output.xlsx');
            })
            .catch((err) => {
              console.log(err, "errrrrrrrrrrrrrrrr");
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            });
        } else {
          const requestParam = {
            usecaseId: selectedUsecaseeId,
            category_Id: selectedCategoryId,
            folder_id: selectedFolderId,
            scenario_id: selectedScenarioId,
          };
          const urls = API_BASE_URL + RERUN_NUTRITION_DETAILS_API;
          axios({
            url: urls,
            method: "post",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          })
            .then((response) => {
              if (response?.data?.toLowerCase() === "success") {
                //handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                // setReRunStatus("Rerun Done Successfully")

                setReRunSuccess(true);
                handleRerunData();
              } else {
                handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                setReRunStatus(
                  "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
                );
                //handleRerunData();
              }

              // dispatch(enableEditFilter(false, 'handlecat'));
              // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
              //FileSaver(blob, Date.now() + '.xlsx');
              // FileSaver(blob, 'Optimized Output.xlsx');
            })
            .catch((err) => {
              console.log(err, "errrrrrrrrrrrrrrrr");
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            });
        }
      } else {
        if (selectedCategoryId === 1) {
          const requestParam = {
            usecaseId: selectedUsecaseeId,
            category_Id: selectedCategoryId,
            folder_id: selectedFolderId,
            scenario_id: selectedScenarioId,
          };
          const urls = API_BASE_URL + RERUN_MEDIUM_HOMECARE_DETAILS_API;

          // const urls = API_BASE_URL + RERUN_HOMECARE_DETAILS_API;
          axios({
            url: urls,
            method: "post",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          })
            .then((response) => {
              if (response?.data?.toLowerCase() === "success") {
                //handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                setReRunSuccess(true);
                handleRerunData();
              } else {
                handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                setReRunStatus(
                  "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
                );
                //handleRerunData();
              }
              // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
              //FileSaver(blob, Date.now() + '.xlsx');
              // FileSaver(blob, 'Optimized Output.xlsx');
            })
            .catch((err) => {
              console.log(err, "errrrrrrrrrrrrrrrr");
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            });
        } else {
          const requestParam = {
            usecaseId: selectedUsecaseeId,
            category_Id: selectedCategoryId,
            folder_id: selectedFolderId,
            scenario_id: selectedScenarioId,
          };
          const urls = API_BASE_URL + RERUN_MEDIUM_NUTRITION_DETAILS_API;
          axios({
            url: urls,
            method: "post",
            headers: { "Content-Type": "application/json;" },
            data: requestParam,
          })
            .then((response) => {
              if (response?.data?.toLowerCase() === "success") {
                //handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));

                setReRunSuccess(true);
                handleRerunData();
              } else {
                handleOpenReRunDialog();
                dispatch(enableEditFilter(false, "handlecat"));
                setReRunStatus(
                  "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
                );
                //handleRerunData();
              }

              // dispatch(enableEditFilter(false, 'handlecat'));
              // let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
              //FileSaver(blob, Date.now() + '.xlsx');
              // FileSaver(blob, 'Optimized Output.xlsx');
            })
            .catch((err) => {
              console.log(err, "errrrrrrrrrrrrrrrr");
              handleOpenReRunDialog();
              dispatch(enableEditFilter(false, "handlecat"));
              setReRunStatus(
                "Module run is unsuccessful. Please connect with Darshan (darshan.gosalia@unilever.com) for assistance",
              );
              //handleRerunData();
            });
        }
      }
    };

    let statusCountReRun = 0;
    let processingCountReRun = 0;
    let failedCountReRun = 0;
    useEffect(() => {
      if (selectedCategoryId > 0 && selectedUsecaseId > 0) {
        if (reRunSuccess) {
          rerunUploadStatusData.map((item: any) => {
            var statusstring = item.status;
            if (statusstring?.toLowerCase().includes("successfully")) {
              statusCountReRun++;
              if (intervalId !== null) {
                clearInterval(intervalId);
              }
            }
            if (statusstring?.toLowerCase().includes("Processing")) {
              processingCountReRun++;
            }
            if (statusstring?.toLowerCase().includes("failed")) {
              failedCountReRun++;
              if (intervalId !== null) {
                clearInterval(intervalId);
              }
            }
          });
        }
        if (
          rerunUploadStatusData.length > 0 &&
          statusCountReRun === rerunUploadStatusData.length
        ) {
          setReRunDialogStatus("Data uploaded successfully!");

          if (intervalId !== null) {
            clearInterval(intervalId);
          }
          setReRunLoading(false);
        }
        // if (processingCountReRun > 0) {
        //   setReRunDialogStatus("Data upload in Progress");
        // }
        if (failedCountReRun > 0) {
          setReRunDialogStatus("Data upload Failed");
          if (intervalId !== null) {
            clearInterval(intervalId);
          }
          setReRunLoading(false);
        }
      }
    }, [rerunUploadStatusData, selectedCategoryId, selectedUsecaseId]);

    const handleUploadNow = (e: any, type: string) => {
      setIsFileUploadStatus(true);
      e.preventDefault();
      let formData = new FormData();
      if (selectRadio === "inputData") {
        getInputLineData.map((itm: any) => {
          if (!_.isEmpty(itm.selectedFile.name)) {
            formData.append("files", itm.selectedFile);
          }
        });
      } else {
        getMasterData.map((itm: any) => {
          if (!_.isEmpty(itm.selectedFile.name)) {
            formData.append("files", itm.selectedFile);
          }
        });
      }

      let filesList = selectedfilesList;
      let initialValues = {
        usecase: selectedUsecaseeId,
        category: selectedCategoryId,
        folder:
          uploadSelectedFolderId !== ""
            ? uploadSelectedFolderId
            : selectedFolderId,
        scenario: uploadScenarioId,
      };

      let fileType = "";
      if (selectRadio === "inputData" && scenarioData?.type === "scenario") {
        fileType = "scenario";
      } else if (selectRadio === "inputData") {
        fileType = "baseline";
      } else {
        fileType = "master";
      }
      setFileTypeName(fileType);
      // Handle isCreateFolder and isScenarioCreated conditions
      if (
        selectRadio === "inputData" &&
        isCreateFolder &&
        isUploadBaseLineData
      ) {
        // Baseline upload after folder creation
        dispatch(
          actions.onInitUloadMasterFile(
            formData,
            filesList,
            "baseline",
            initialValues,
            type,
            "",
            "shortTerm1",
            userData.userId,
          ),
        );
        setFileTypeName("baseline");
      } else if (
        selectRadio === "inputData" &&
        scenarioData?.type === "scenario" &&
        isScenarioCreated
      ) {
        // Scenario upload after scenario creation
        dispatch(
          actions.onInitUloadMasterFile(
            formData,
            filesList,
            "scenario",
            initialValues,
            type,
            "",
            "shortTerm",
            userData.userId,
          ),
        );
        setFileTypeName("scenario");
      } else {
        // Default upload
        dispatch(
          actions.onInitUloadMasterFile(
            formData,
            filesList,
            fileType,
            initialValues,
            type,
            "",
            "shortTerm2",
            userData.userId,
          ),
        );
      }
      setSelectedFilesList([]);
      handleOpen();
      setIsUploadMasterFile(true);

      // if (
      //   selectRadio === "inputData" &&
      //   isCreateFolder &&
      //   isUploadBaseLineData
      // ) {
      //   //dispatch(actions.onInitBaseLineUpload(formData, inputFolderValue));

      //   getSasUrlApi("baseline");
      //   setFileTypeName("baseline");
      // } else if (
      //   selectRadio === "inputData" &&
      //   scenarioData?.type === "scenario" &&
      //   isScenarioCreated
      // ) {
      //   //dispatch(actions.onInitScenarioLineUpload(formData, scenarioData));
      //   getSasUrlApi("scenario");
      //   setFileTypeName("scenario");
      // } else {
      //   let fileType = "";
      //   if (selectRadio === "inputData" && scenarioData?.type === "scenario") {
      //     fileType = "scenario";
      //   } else if (selectRadio === "inputData") {
      //     fileType = "baseline";
      //   } else {
      //     fileType = "master";
      //   }
      //   getSasUrlApi(fileType);
      //   setFileTypeName(fileType);
      // }
      // setIsUploadMasterFile(true);

      // dispatch(fileUploadStatus(true));
    };

    const handleGoBack = () => {
      dispatch(goBack());
      setIsNext(false);
      setSelectedOption("");
    };

    //
    console.log(selectRadio, "selectRadioselectRadio");
    const handleNext = (e: any) => {
      setIsLongTermNext(false);
      e.preventDefault();

      setIsNext(true);
      if (isSelectedScenarios === true) {
        if (selectRadio === "masterData") {
          localStorage.setItem("selectCGOInput", "CGOInput");
          setSelectedOption("CGOMaster");
        } else {
          setSelectedOption("CGOInput");

          let useCase = localStorage.getItem("selectedUsecase");
          if (useCase === "COG") {
            localStorage.setItem("selectCGOInput", "CGOInput");
            window.location.href = "/CGOHome";
          } else {
            localStorage.setItem("selectCGOInput", "LongTermInput");
            window.location.href = "/LongTermHome";
          }
        }
      }
    };

    const handleBack = (e: any) => {
      e.preventDefault();
      setIsNext(false);
      dispatch(closeModal());
    };

    const style = {
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: 700,
      bgcolor: "background.paper",
      border: "2px solid #000",
      boxShadow: 24,
      p: 4,
    };

    const [open, setOpen] = React.useState(false);

    const scenarioNumber = useSelector(
      (state: any) => state.InputDataReducers.scenarioNumber,
    );

    var scenario_id = "";
    if (selectedScenarioId === "" || selectedScenarioId === 0) {
      scenario_id = scenarioNumber;
    } else {
      scenario_id = selectedScenarioId;
    }

    const handleClose = () => {
      if (isLongtermNext) setIsLongTermNext(false);
      if (isLongTermUploadModal) setIsLongTermUploadModal(false);
      if (isNextLongTerm) setIsNextLongTerm(false);
      if (isOpenProceedModal) setIsOpenProceedModal(false);
      if (isOpenLongTermScenarioModal) setIsOpenLongTermScenarioModal(false);
    };

    // close uploading  file popup
    useEffect(() => {
      if (isDone) {
        setIsUploadMasterFile(false);
        // dispatch(selectBaseLineCost());
        setIsUploadModal(false);
        //closeUploadModal();
        // dispatch(selectedUsecaseListSuccess(selectedUsecaseeId));
        // dispatch(selectedCategoryListSuccess(selectedCategoryId));
      }
    }, [isDone, isFolderCreated]);

    useEffect(() => {
      if (selectedUsecaseeId !== 0 && selectedCategoryId !== 0) {
        callFolderFilterApi(selectedUsecaseeId, selectedCategoryId);
      }
    }, [isFolderCreated]);

    const handleCloseReRunStatus = () => {
      setOpenEditDialog(false);
    };

    const handleReRunDialog = () => {
      setIsEditFileStatus(false);
    };

    const handleReRunDialogStatus = () => {
      setUploadReRunStatus(false);
    };

    const handleBackDropClick = (e: any) => {
      if (modelRef.current === e.target) {
        e?.stopPropagation();
      }
    };

    const handleReRunSuccess = () => {
      setIsEditFileStatus(false);
    };
    const handleOpenCloseEditDialog = () => {
      setOpenEditDialog(true);
    };

    const handleCloseReRunDialog = () => {
      setOpenReRunDialog(false);
    };

    const handleOpenReRunDialog = () => {
      setOpenReRunDialog(true);
    };

    const doneSelect = () => {
      let useCase = localStorage.getItem("selectedUsecase");
      console.log(useCase, "useCaseuseCase");

      setIsLongTermNext(false);

      localStorage.setItem("selectedRadio", selectRadio);

      // Show Create or Existing scenario selection
      if (isSelectedScenarios === true) {
        if (useCase === "Short Term" || useCase === "Medium Term") {
          // setIsOpenProceedModal(true);
          setIsSelectedScenarios(false);
          setIsUploadModal(true);
        } else {
          if (selectRadio === "inputData") {
            setSelectedOption("CGOInput");

            if (useCase === "COG") {
              localStorage.setItem("selectCGOInput", "CGOInput");
              window.location.href = "/CGOHome";
            } else {
              localStorage.setItem("selectCGOInput", "LongTermInput");
              window.location.href = "/LongTermHome";
            }
          } else {
            if (useCase === "Long Term Analysis") {
              localStorage.setItem("selectedUsecase", "Long Term Analysis");
              // legacy long term flow (Nakshatra + folder) is now handled via
              // dedicated LongTermScenarioSelectionModal, so just close the
              // generic proceed modal here.
              setIsOpenProceedModal(false);
            } else {
              setIsLongTermNext(false);
              setSelectedOption("CGOMaster");
              localStorage.setItem("selectCGOInput", "CGOInput");
            }
          }
        }
      } else {
        setSelectedOption("");
        localStorage.setItem("selectCGOInput", "");
        setIsUploadModal(false);
        window.location.href = "/Home";
      }
    };

    const handleCloseFolder = () => {
      setIsNextLongTerm(false);
      setIsLongTermNext(true);
    };
    const closeLongTermCapacityModal = () => {
      setIsLongTermNext(false);
    };

    const handleGoBackLongTerm = () => {
      let useCase = localStorage.getItem("selectedUsecase") || "";
      localStorage.setItem("selectedUsecase", useCase);
      setIsOpenLongTermScenarioModal(false);
      setIsOpenProceedModal(true);
      dispatch(addProcessingPackagingPlantsDiff(true));
      dispatch(addSourceBePartOfOptimization(true));
      dispatch(addPackingPlantAddMinorIngredient(true));
    };
    const [inputCapacityModalData, setInputCapacityModalData] = useState({});
    const handleNextLongTerm = (data: any) => {
      setInputCapacityModalData(data);
      setIsLongTermNext(false);
      setIsNextLongTerm(true);
    };

    const [folderValue, setFolderValue] = useState<any>("");
    const [scenarioValue, setScenarioValue] = useState<any>("");

    const getNewFolderData = (data: any) => {
      setFolderValue(data.folderValue);
    };

    const handleCreateNewFolder = (data: any) => {
      dispatch(createrFolderOrScenarioError(""));
      const fromCombinedModal = data.fromCombinedModal === true;
      const apiEndPoint = data.isCreateNewFolder
        ? LONG_ADD_FOLDERSCENARIO_GET_API
        : LONG_ADD_SCENARIO_GET_API;
      setFolderValue(data.folder || data.folder_id);
      delete data["isCreateNewFolder"];
      delete data["fromCombinedModal"];
      const urls = API_BASE_URL + apiEndPoint;
      const params = data;
      postRequest(urls, params, {})
        .then((response: any) => {
          if (response.status === 200 && response) {
            setScenarioValue(response?.data?.data?.split(",")[1]);
            setFolderValue(response?.data?.data?.split(",")[0]);
            if (!response.data.success) {
              // setFolderCreationErrorMessage(response.data.message);
              dispatch(createrFolderOrScenarioError(response.data.message));
            } else if (!fromCombinedModal) {
              setIsLongTermUploadModal(true);
            }
          }
        })
        .catch((error: any) => {
          console.log(error);
        });
    };

    const handleOpenLongTermModal = () => {
      setIsLongTermUploadModal(false);
      setIsNextLongTerm(true);
    };

    const handleClearCreatedFolder = () => {
      setFolderValue("");
      setScenarioValue("");
    };
    console.log(isErrorDialog, "isErrorDialog landing");
    return (
      <div>
        {isLongTermUploadModal && (
          <LongTermUploadModal
            isOpen={isLongTermUploadModal}
            onClose={handleClose}
            selectedFolderId={folderValue}
            selectedScenarioId={scenarioValue}
            handleGoBack={handleOpenLongTermModal}
            selectRadio={selectRadio}
            showCrossMark={false}
          />
        )}
        {isOpenLongTermScenarioModal && (
          <LongTermScenarioSelectionModal
            isOpen={isOpenLongTermScenarioModal}
            onClose={handleClose}
            onViewExistingScenario={() => {
              localStorage.setItem("selectedUsecase", "Long Term Analysis");
              localStorage.setItem("selectCGOInput", "LongTermInput");
              setIsOpenLongTermScenarioModal(false);
              window.location.href = "/LongTermHome";
            }}
            handleCreateNewFolder={handleCreateNewFolder}
            handleGoBack={handleGoBackLongTerm}
            createdFolderId={folderValue}
            createdScenarioId={scenarioValue}
            onClearCreatedFolder={handleClearCreatedFolder}
          />
        )}
        {isNextLongTerm && (
          <FolderModal
            isOpen={isNextLongTerm}
            onClose={handleClose}
            handleCreateNewFolder={handleCreateNewFolder}
            getNewFolderData={getNewFolderData}
            inputCapacityModalData={inputCapacityModalData}
            handleGoBack={handleCloseFolder}
          />
        )}
        {isLongtermNext && (
          <InputCapacityModal
            isOpen={isLongtermNext}
            onClose={handleClose}
            isNext={isNextLongTerm}
            handleNext={handleNextLongTerm}
            handleGoBack={handleGoBackLongTerm}
            selectRadio={selectRadio}
          />
        )}
        {/* Short term and medium term */}
        {isOpenUploadModal && (
          <UploadModal
            isOpen={isOpenUploadModal}
            onClose={closeUploadModal}
            isNext={isNext}
            selectRadio={selectRadio}
            isUploadScenarioData={isUploadScenarioData}
            isSelectedScenarios={isSelectedScenarios}
            handleChangeRadio={handleChangeRadio}
            handleNext={handleNext}
            handleGoBack={handleGoBack}
            handleCloseDonePopup={handleCloseDonePopup}
            handleOpenBaseLineUploader={handleOpenBaseLineUploader}
            handleUploadNow={(e: any) => handleUploadNow(e, "uploadnow")}
            handleBack={handleBack}
            isUploadMasterFile={isUploadMasterFile}
            hiddenFileInput={hiddenFileInput}
            handleCancelFile={handleCancelFile}
            handleUploadFile={handleUploadFile}
            handleChangeFileUpload={handleChangeFileUpload}
            getData={selectRadio === "inputData" ? {} : {}}
            selectedfile={selectedfile}
            isUploadBaseLineData={isUploadBaseLineData}
            doneSelect={doneSelect}
            selectedOption={selectedOption}
          />
        )}

        {isErrorDialog && (
          <ErrorDialog
            isErrorDialog={isErrorDialog}
            errorMessage={errorMessage}
          />
        )}

        {/* COG and Longterm */}
        {isOpenProceedModal && (
          <UploadModal
            isOpen={isOpenProceedModal}
            onClose={closeUploadModal}
            isNext={isNext}
            isSelectedScenarios={isSelectedScenarios}
            selectRadio={selectRadio}
            isUploadScenarioData={isUploadScenarioData}
            handleChangeRadio={handleChangeRadio}
            handleNext={doneSelect}
            handleGoBack={handleGoBack}
            handleCloseDonePopup={handleCloseDonePopup}
            handleOpenBaseLineUploader={handleOpenBaseLineUploader}
            handleUploadNow={(e: any) => handleUploadNow(e, "uploadnow")}
            handleBack={handleBack}
            isUploadMasterFile={isUploadMasterFile}
            hiddenFileInput={hiddenFileInput}
            handleCancelFile={handleCancelFile}
            handleUploadFile={handleUploadFile}
            handleChangeFileUpload={handleChangeFileUpload}
            getData={selectRadio === "inputData" ? {} : {}}
            selectedfile={selectedfile}
            isUploadBaseLineData={isUploadBaseLineData}
            doneSelect={doneSelect}
            selectedOption={selectedOption}
          />
        )}

        <div className="explore-app">
          <h6>Select the time frame for optimization</h6>

          <section className="ac-container">
            <div>
              <input id="ac-1" name="accordion-1" type="radio" />
              <label htmlFor="ac-1">Short term Analysis</label>
              <article className="ac-small">
                <p>
                  Optimize current network by using existing plants for
                  efficient demand fulfillment and infrastructure utilization.
                </p>
                <br></br>
                <Button
                  className="btn-proceed"
                  variant="contained"
                  onClick={() => openShortTermPopup("Short Term")}
                >
                  Proceed &nbsp; &#10140;
                </Button>
              </article>
              <div className="clear"></div>
            </div>
            <div>
              <input id="ac-2" name="accordion-1" type="radio" />
              <label htmlFor="ac-2">Medium term Analysis</label>
              <article className="ac-small">
                <p>
                  Optimize network by identifying new potential capacity
                  expansions within existing plants for efficient demand
                  fulfillment and resource utilization.{" "}
                </p>
                <br></br>

                <Button
                  className="btn-proceed"
                  variant="contained"
                  onClick={() => openShortTermPopup("Medium Term")}
                >
                  Proceed &nbsp; &#10140;
                </Button>

                <div className="clear"></div>
              </article>
            </div>
            <div>
              <input id="ac-3" name="accordion-1" type="radio" />
              <label htmlFor="ac-3">Long term Analysis</label>
              <article className="ac-small">
                <p>
                  Optimize network by identifying new facilities, capacity
                  boosts, and closures for efficient, forward-looking demand
                  fulfillment and future expansion.{" "}
                </p>
                <br></br>
                <Button
                  className="btn-proceed"
                  variant="contained"
                  onClick={() => pageLTRedirection("Long Term Analysis")}
                >
                  Proceed &nbsp; &#10140;
                </Button>

                <div className="clear"></div>
              </article>
            </div>
            <div>
              <input id="ac-4" name="accordion-1" type="radio" />
              <label htmlFor="ac-4">Centre of Gravity Analysis</label>
              <article className="ac-small">
                <p>
                  COG analysis identifies optimal plant locations, meeting
                  demands efficiently based on least weighted distance.{" "}
                </p>
                <br></br>
                <Button
                  className="btn-proceed"
                  variant="contained"
                  onClick={() =>
                    pageCGORedirection("Centre of Gravity Analysis")
                  }
                >
                  Proceed &nbsp; &#10140;
                </Button>

                <div className="clear"></div>
              </article>
            </div>
          </section>
        </div>

        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="inherit"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          {types.map((type, index) => (
            <Tab className="tabview" label={type} {...a11yProps(index)} />
          ))}
        </Tabs>
        <p />
      </div>
    );
  };

  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleSignOut = () => {
    setAnchorElUser(null);
    signOutClickHandler(instance);
  };

  return (
    <div className="App">
      {/* Header section */}
      <header className="app-header">
        <div className="unilever-ops-logo">
          <img src={unileverLogo} alt="logo" />
          <img src={uniopsLogo} alt="logo" />
        </div>
        <div className="login-info">
          <Box
            onClick={handleOpenUserMenu}
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
            }}
          >
            <div className="welcome-info">
              <span className="user-name" style={{ paddingBottom: "8px" }}>
                {userData ? userData.userName : "User"}
              </span>
              <span style={{ fontSize: "13px", color: "#666" }}>
                {userData?.userType} - {userData?.groupName}
              </span>
            </div>
            <KeyboardArrowDown
              sx={{
                ml: 0.5,
                transform: openUserMenu ? "rotate(180deg)" : "none",
              }}
            />
          </Box>
          <Menu
            anchorEl={anchorElUser}
            open={openUserMenu}
            onClose={handleCloseUserMenu}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem onClick={handleSignOut}>
              <ListItemIcon>
                <Logout fontSize="small" />
              </ListItemIcon>
              Sign Out
            </MenuItem>
          </Menu>
        </div>
      </header>

      {/* Main body section */}
      <div className="top-block">
        <div className="left-block">
          <div>
            <h4>SAKSHAM</h4>
            <h1>Supply Chain Network Optimizer</h1>
          </div>
        </div>
        <div className="right-block">
          <div id="root"></div>
        </div>
      </div>
      <div className="middle-block" id="ViewMore">
        <a className="learn-more" href="#mainBody2">
          Learn more about the app <i className="arrow down"></i>
        </a>
        <h1>
          <span>We have added more features to the new Network Optimizer.</span>
        </h1>
        <div className="tab-container" id="mainBody2">
          <TabGroup />
          <TabPanel value={value} index={0}>
            <ul>
              <li>
                5 Modules in one place to collect, validate and track your
                innovation information.
              </li>
              <li>Better user experience and feedback loop.</li>
              <li>Seamless integration that actually helps with the data.</li>
            </ul>
            <div className="rect-box">
              <video controls style={{ width: "90%" }}>
                <source src="NetworkOptimizerApp.mp4" type="video/mp4" />
              </video>
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <ul>
              <li>Planner - Homecare and Nutrition</li>
              <li>Suit - Homecare and Nutrition</li>
              <li>Nakshatra - Homecare and Nutrition </li>
            </ul>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <ul>
              <li>Duplicate Scenario</li>
              <li>Edit Scenario</li>
              <li>Rerun</li>
            </ul>
          </TabPanel>
        </div>
      </div>
      <div className="download-block">
        <div
          className="go-app-container"
          onClick={() => (window.location.href = "/Home")}
        ></div>

        <span className="download-guide" onClick={handleDownload}>
          Download complete guide <img src={DownloadIcon} alt="download icon" />
        </span>
      </div>
      <div className="footer">
        <div className="f-nav-container">
          <img
            className="unilever-ops-logo"
            src={uniopsLogo}
            alt="unilever OPS logo"
          />
          <ul className="f-nav">
            <li>
              <a href="#">How N/W Optimizer works</a>
            </li>
            <li>
              <a href="#">FAQ’s</a>
            </li>
          </ul>
        </div>
        <div className="contact">
          <span>contact</span>
          <a href="tomail:help@unilver.com">help@unilver.com</a>
        </div>
      </div>
      {/* Footer section */}
      <a href="#" className="back-to-top">
        <img src={arrowUpicon} alt="arrow up icon" />
      </a>
    </div>
  );
}

export default Landingv2;
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
